<template>
  <div class="">
    <div class="">
      <form @submit.prevent="uploadExitedStaff" class="">
        <div class="text-2xl mt-3 lg:mt-0 text-[#09518C]">Exited Employee</div>
        <p class="mt-2 lg:mt-6 py-4 border-t-2">
          Click
          <a
            class="text-[#8dc63f]"
            target="_blank"
            href="https://toolkitapi-staging.armpension.com/public/sample/ExitedStaffTemplate.xlsx"
            >here</a
          >
          to download a copy of our exited staff template
        </p>
        <div
          class="border-dotted border-2 bg-gray-100 rounded p-4 flex md:w-[50%]"
        >
          <div class="flex justify-center items-center w-full">
            <label
              for="dropzone-file"
              class="flex flex-col justify-center items-center w-full h-36 bg-gray-50 rounded-lg border-2 border-gray-300 border-dashed cursor-pointer dark:hover:bg-bray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
            >
              <div class="flex flex-col justify-center items-center p-3">
                <svg
                  aria-hidden="true"
                  class="mb-3 w-10 h-10 text-gray-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                  ></path>
                </svg>
                <p
                  v-if="fileName === ''"
                  class="mb-2 text-sm text-center text-gray-500 dark:text-gray-400"
                >
                  <span class="font-semibold"
                    >Click to upload exited employee</span
                  >
                </p>

                <p
                  v-if="fileName === ''"
                  class="text-xs text-gray-500 dark:text-gray-400"
                >
                  .xls, .xlsx, .csv
                </p>
                <div class="text-[#09518c]">{{ fileName }}</div>
              </div>
              <input
                id="dropzone-file"
                type="file"
                accept=".xls, .xlsx, .csv"
                @change="onFileChange"
                class="hidden"
              />
            </label>
          </div>
        </div>
        <div class="my-4 flex w-full">
          <button
            :disabled="!fileName || loading === true"
            :class="!fileName ? 'bg-[#d5f7a5]' : 'bg-[#8DC63F]'"
            class="text-white w-full md:w-[50%] py-2 px-4 uppercase rounded-md hover:text-[#F58220] hover:bg-white hover:border-[#8DC63F] border transition-colors duration-300"
          >
            <span v-if="loading === true">
              <div role="status" class="flex justify-center w-full">
                <svg
                  class="inline mr-2 w-5 h-5 text-white animate-spin dark:text-gray-600 fill-[#09518c]"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill"
                  />
                </svg>
                <span class="sr-only">Loading...</span>
              </div>
            </span>
            <span v-else>Upload Exited Staff List</span>
          </button>
        </div>
      </form>
    </div>

    <SuccessModal v-if="isSuccessModalOpen" @close="isSuccessModalOpen = false">
      <template #message>
        <div class="text-center" v-if="exitUploadMessage">
          <div class="">
            <font-awesome-icon
              class="text-green-600 z-20 h-28 py-2"
              icon="fa-check-circle"
            />
          </div>
          <div class="py-2">
            <div class="p-4 text-black">
              <!-- v-if="exitUploadMessage !== null" -->
              <div class="text-lg font-bold text-center">
                Exited Staff Request Submitted Successfully
              </div>
              <div class="mt-4 text-sm text-center font-normal">
                Kindly track processing status from Ticket menu using Case
                Number
                <div class="block font-bold">
                  {{ exitUploadMessage }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center" v-if="exitUploadMessageError">
          <div class="">
            <font-awesome-icon
              class="text-red-600 z-20 h-28 py-2"
              icon="fa-check-circle"
            />
          </div>
          <div class="py-2">
            <div class="p-4 text-black">
              <div class="text-lg font-bold text-center">
                Exited Staff Request failed
              </div>
              <div class="mt-4 text-sm text-center font-bold">
                {{ exitUploadMessageError }}
              </div>
            </div>
          </div>
        </div>
      </template>
    </SuccessModal>
  </div>
</template>

<script>
import { ref } from "@vue/reactivity";
import { toolkitAxios, engageAxios } from "@/env";
import { useStore } from "vuex";
import SuccessModal from "@/components/modals/modal";
export default {
  components: {
    SuccessModal,
  },
  setup() {
    const upload_file = ref("");
    const fileName = ref("");
    const file = ref("");
    const loading = ref(false);
    const exitUploadMessage = ref("");
    const exitUploadMessageError = ref("");
    const store = useStore();
    const isSuccessModalOpen = ref(false);

    const onFileChange = () => {
      file.value = document.querySelector("input[type=file]").files[0];
      const reader = new FileReader();

      reader.addEventListener(
        "load",
        () => {
          upload_file.value = reader.result;
          // console.log(reader.result);
        },
        false
      );

      if (file.value) {
        reader.readAsDataURL(file.value);
        fileName.value = file.value.name;
      }
    };

    const uploadExitedStaff = async () => {
      loading.value = true;

      let finalDesc = store.state.getLoggedInUser.code;

      const finalDto = {
        caseOriginCode: "700000008",
        employerCode: store.state.getLoggedInUser.code,
        interactionType: "700000000",
        interactionCategory: "bddc2993-081d-eb11-a813-000d3a64a52d",
        interactionSubCategory: "c47be674-091d-eb11-a813-000d3a64a52d",
        documents: upload_file.value,
        caseDescription: finalDesc,
        agentCode: store.state.getLoggedInUser.rmu_code,
        autoRoute: true,
        subject: store.state.getLoggedInUser.code + "-Exited Staff",
      };

      return new Promise((resolve, reject) => {
        engageAxios
          .post("crm/case/employer/createcase", finalDto)

          .then((response) => {
            let postData = new FormData();
            postData.append("code", finalDto.employerCode);
            postData.append("agentCode", finalDto.agentCode);
            postData.append("document", file.value, finalDto.subject);
            fileName.value = "";

            // console.log("response", response);
            if (response.data.status != "fail") {
              toolkitAxios.post("case/exitedStaff", postData).then((res) => {
                exitUploadMessage.value = response.data.data.caseNumber;
                isSuccessModalOpen.value = true;
                loading.value = false;
                resolve(res);
              });
            } else {
              exitUploadMessageError.value =
                "An error occured when submitting your request, please try again later.";
              isSuccessModalOpen.value = true;
              loading.value = false;
            }

            file.value = "";

            resolve(true);
          })
          .catch((error) => {
            exitUploadMessageError.value =
              "An error occured when submitting your request, please try again later.";
            isSuccessModalOpen.value = true;
            loading.value = false;
            reject(error);
          });
      });
    };

    return {
      upload_file,
      onFileChange,
      uploadExitedStaff,
      fileName,
      loading,
      exitUploadMessage,
      isSuccessModalOpen,
      exitUploadMessageError,
    };
  },
};
</script>

<style>
.bg {
  background-color: white;
}
</style>
